import { render } from "./ProductSearch.vue?vue&type=template&id=453f4a1c&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"

import "./ProductSearch.vue?vue&type=style&index=0&id=453f4a1c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453f4a1c"]])

export default __exports__